export enum EmployeeRewardDisciplineType {
  Reward = "REWARD",
  Discipline = "DISCIPLINE",
}

export interface EmployeeRewardDiscipline {
  id: number;
  employeeId: number;
  employeeCode?: string;
  organizationId?: number;
  date: string;
  type: EmployeeRewardDisciplineType;
  rewardDecision?: string;
  disciplineRecord?: string;
  content?: string;
  result?: string;
  note?: string;
  status?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface EmployeeRewardDisciplineListRequest {
  page?: number;
  limit?: number;
  type?: EmployeeRewardDisciplineType;
  employeeId?: number;
  empIds?: string;
  employeeCode?: string;
  startDate?: string;
  endDate?: string;
  keyword?: string | null;
  status?: number | null;
}

export interface EmployeeRewardDisciplineCreateRequest {
  employeeId: number;
  employeeCode?: string;
  date?: string;
  type?: EmployeeRewardDisciplineType;
  rewardDecision?: string;
  disciplineRecord?: string;
  content?: string;
  result?: string;
  note?: string;
  status?: number;
}

export interface EmployeeRewardDisciplineUpdateRequest
  extends Partial<EmployeeRewardDisciplineCreateRequest> {
  id: string;
}

export interface EmployeeRewardDisciplineListResponse
  extends RestAPIMetaResponse {
  items: Array<EmployeeRewardDiscipline>;
}
